/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/space.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a string made of `number` spaces.
 *
 * @example
 * ROW message = CONCAT("Hello", SPACE(1), "World!");
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'space',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
